var o = /* @__PURE__ */function (M) {
    return M.NORMAL = "normal", M.MINI = "mini", M.JUMBO = "jumbo", M.MAXI = "maxi", M;
  }(o || {}),
  a = /* @__PURE__ */function (M) {
    return M.NORMAL = "normal", M.MINI = "mini", M.JUMBO = "jumbo", M;
  }(a || {});
export { o as M, a as o };